module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.library.js
// module id = 40
// module chunks = 0